export default __webpack_public_path__ + "static/media/82_desktop.fbe2cc61.jpg";